module.exports = __webpack_public_path__ + "static/homepageGif-23a9ee4d02e4a001b3f85ff4e4fd3ee1.gif";